import { REGEXP } from 'constants/commonConstants';
import * as yup from 'yup';

export default yup.object().shape({
  password: yup.string().required('비밀번호를 입력해주세요'),
  newPassword: yup
    .string()
    .required('새 비밀번호를 입력해주세요.')
    .matches(REGEXP.PASSWORD, '8자-32자의 비밀번호를 입력해주세요.'),
  passwordConfirm: yup
    .string()
    .required('새 비밀번호를 다시 입력해주세요.')
    .oneOf([yup.ref('newPassword')], '비밀번호가 일치하지 않습니다.'),
});
